import type { ISerialize } from '@/objects/ISerialize';

export class ProductionEventStationRole implements ISerialize {
    public ID: number;

    public Name: string | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { ID?: number; Name?: string | null }) {
        this.ID = values.ID ?? 0;

        this.Name = values.Name ?? '';
    }

    public serialize(): string {
        return '{' + `"ID": ${JSON.stringify(this.ID)}` + ',' + `"Name": ${JSON.stringify(this.Name)}` + '}';
    }

    /**
     * Creates an instance of ProductionEventStationRole from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { ID?: number; Name?: string | null }): ProductionEventStationRole {
        return new ProductionEventStationRole(values);
    }

    public static _FromServerJson(json: any): ProductionEventStationRole {
        return new ProductionEventStationRole({ ID: json.ID, Name: json.Name ?? '' });
    }

    /**
     * Creates an instance of ProductionEventStationRole from another instance of ProductionEventStationRole.
     * @param other The ProductionEventStationRole you want to clone
     * @returns A cloned ProductionEventStationRole
     */
    public static FromOther(other: ProductionEventStationRole): ProductionEventStationRole {
        return ProductionEventStationRole._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ProductionEventStationRole.FromOther(this);
    }

    static NAME_OF_CLASS = 'ProductionEventStationRole';
}
